export class newConnectionLoginModel {
    "transactionId"			: string = "";
    "transactionPassword"			: string = "";
  }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/newConnectionLogin/newConnectionLogin.model.ts